if (!customElements.get("ona-spinner")) {
  customElements.define(
    "ona-spinner",
    class extends HTMLElement {
      constructor() {
        super();
        this.attachShadow({ mode: "open" });
      }
      connectedCallback() {
        const templateId = this.getAttribute("template") || "ona-spinner-template";
        const customTemplate = document.getElementById(templateId);
        if (customTemplate) {
          this.shadowRoot.appendChild(customTemplate.content.cloneNode(true));
        } else {
          this.shadowRoot.innerHTML = `
            <style>
              :host {
                display: inline-block;
                width: var(--ona-spinner-size, 24px);
                height: var(--ona-spinner-size, 24px);
                border: var(--ona-spinner-border-width, 2px) solid var(--ona-spinner-bg, rgba(0,0,0,0.1));
                border-left-color: var(--ona-spinner-color, #333);
                border-radius: 50%;
                animation: spin 1s linear infinite;
              }
              @keyframes spin {
                to { transform: rotate(360deg); }
              }
              @media (prefers-reduced-motion: reduce) {
                :host {
                  animation: none;
                }
              }
            </style>
          `;
        }
      }
    }
  );
}
